import { useState, useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from './AuthContext';
import AuthLayout, { authStyles as s } from './components/AuthLayout';
import googleIcon from './assets/images/auth/google.png';
import appleIcon from './assets/images/auth/apple.png';
import facebookIcon from './assets/images/auth/facebook.png';

function disabledClick(e) {
  e.preventDefault();
  alert('준비 중입니다');
}

export default function Login() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.get('error') === 'oauth_failed') {
      setError('Google 로그인에 실패했습니다. 다시 시도해주세요.');
      // URL에서 쿼리 제거
      searchParams.delete('error');
      setSearchParams(searchParams, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  async function onSubmit(e) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      const res = await fetch('/api/auth/login', {
        method: 'POST',
        credentials: 'include',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        setError(data.error === 'invalid_credentials'
          ? '이메일 또는 비밀번호가 올바르지 않습니다.'
          : '로그인에 실패했습니다.');
        return;
      }
      await refresh();
      navigate('/', { replace: true });
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <AuthLayout title="Welcome to InHence">
      <form onSubmit={onSubmit}>
        <div className={s.field}>
          <label className={s.label}>Email</label>
          <input className={s.input} type="email" placeholder="Email"
            value={email} onChange={e => setEmail(e.target.value)} required autoComplete="email" />
        </div>
        <div className={s.field}>
          <label className={s.label}>Password</label>
          <input className={s.input} type="password" placeholder="Password"
            value={password} onChange={e => setPassword(e.target.value)} required autoComplete="current-password" />
        </div>
        {error && <p className={s.error}>{error}</p>}
        <button className={s.primary} type="submit" disabled={submitting}>
          {submitting ? '로그인 중...' : 'Log In'}
        </button>
      </form>

      <div className={s.forgot}>
        <Link to="/forgot-password">Forgot your password?</Link>
      </div>

      <div className={s.divider}><span>Or continue with</span></div>

      <div className={s.ssoRow}>
        <button
          type="button"
          className={s.ssoButton}
          onClick={() => { window.location.href = '/api/auth/google'; }}
          title="Google로 로그인"
        >
          <img src={googleIcon} alt="Google" />
        </button>
        <button className={s.ssoButton} onClick={disabledClick} disabled title="준비 중">
          <img src={appleIcon} alt="Apple" />
        </button>
        <button className={s.ssoButton} onClick={disabledClick} disabled title="준비 중">
          <img src={facebookIcon} alt="Facebook" />
        </button>
      </div>

      <div className={s.footer}>
        <span className={s.question}>Don't have an account?</span>
        <Link to="/signup" className={s.signupLink}>Sign Up Here</Link>
      </div>
    </AuthLayout>
  );
}
